import { useState, useCallback, ReactNode } from "react";

export interface AnimBtnProps {
  onClick?: () => void;
  className?: string;
  children: ReactNode;
  /** pop = 縮小→拡大, bounce = バウンス, shake = エラー振動 */
  animType?: "pop" | "bounce" | "shake";
  /** trueのとき購入系コインエフェクトを表示 */
  coinEffect?: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
}

export default function AnimBtn({
  onClick,
  className = "",
  children,
  animType = "pop",
  coinEffect = false,
  disabled = false,
  type = "button",
}: AnimBtnProps) {
  const [anim, setAnim] = useState(false);
  const [showCoin, setShowCoin] = useState(false);

  const handleClick = useCallback(() => {
    if (disabled) return;
    setAnim(true);
    if (coinEffect) {
      setShowCoin(true);
      setTimeout(() => setShowCoin(false), 700);
    }
    onClick?.();
  }, [disabled, coinEffect, onClick]);

  const animClass =
    animType === "bounce" ? "animate-btn-bounce" :
    animType === "shake"  ? "animate-shake" :
    "animate-btn-pop";

  return (
    <div className="relative inline-flex w-full">
      <button
        type={type}
        onClick={handleClick}
        disabled={disabled}
        onAnimationEnd={() => setAnim(false)}
        className={`${className} ${anim ? animClass : ""} active:scale-95 transition-transform`}
      >
        {children}
      </button>
      {showCoin && (
        <div className="absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none z-50">
          <span className="animate-coin-fly text-amber-400 text-xl font-black">
            <i className="ri-coin-line"></i>
          </span>
        </div>
      )}
    </div>
  );
}
